import { loadOrgLogoAsDataUrl } from "./loadOrgLogoAsDataUrl";
import {
  resolveOrgBranding,
  resolveOrgBrandingFromCache,
} from "./resolveOrgBranding";

/**
 * Resolve branding and load logo data URL for PDF export.
 *
 * @param {import("./resolveOrgBranding").OrgBrandingSnapshot|null|undefined} branding
 * @returns {Promise<{ branding: import("./resolveOrgBranding").OrgBrandingSnapshot, logoDataUrl: string|null }>}
 */
export async function prepareReportPdfBranding(branding) {
  const resolved = branding || resolveOrgBrandingFromCache();
  const logoDataUrl = await loadOrgLogoAsDataUrl(resolved.logoUrl);
  return { branding: resolved, logoDataUrl };
}

export { resolveOrgBranding, resolveOrgBrandingFromCache };
